// @flow

import React from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Button, Text, TextField } from 'gestalt';

type Props = {
  age: ?string,
  error: ?string,
  handleAgeChange: ({ value: string }) => void,
  handleSubmit: () => void,
  inputRef: (c: any) => void,
};

const SocialConnectAgeCollectionForm = (props: Props) => {
  const { age, error, handleAgeChange, handleSubmit, inputRef } = props;
  return (
    <Box>
      <form
        method="post"
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <Box>
          <Text align="left">
            {i18n._(
              'How old are you?',
              'Title for the age collection input field after connecting with Facebook or Google',
            )}
          </Text>
        </Box>
        <Box marginTop={2} />
        <Box>
          <TextField
            id="age"
            errorMessage={error || ''}
            onChange={handleAgeChange}
            placeholder={i18n._('Age', 'text field for user to enter their age')}
            ref={(c) => {
              if (inputRef) {
                inputRef(c);
              }
            }}
            type="number"
          />
        </Box>
        <Box marginTop={3} />
        <Box>
          <Button color="red" disabled={!age} text={i18n._('Continue')} type="submit" />
        </Box>
      </form>
    </Box>
  );
};

export default SocialConnectAgeCollectionForm;
